import { Stack, Typography, useTheme, styled, SxProps, Theme } from '@mui/material';
import { LINK_SUPPORT } from 'src/utils/constants/config';
import { ICON_SUPPORT_NO_DATA_COMPANY, ICON_NO_DATA_COMPANY } from 'src/utils/constants/imagesUrl';
import { StyledWhiteBox } from 'src/features/CompanyDetail/config';
import ImageComponent from 'src/components/common/Image';

// Utilities

const Link = styled('a')(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: '0px 3px',
  // textDecoration: 'underline',
}));

const CompanyInfoNoData = ({
  title,
  content,
  sxContainer,
}: {
  title: string;
  content: React.ReactNode;
  sxContainer?: SxProps<Theme>;
}) => {
  const theme = useTheme();

  return (
    <StyledWhiteBox
      display="flex"
      flexDirection="column"
      border={`1px solid ${theme.palette.divider}`}
      sx={{ ...sxContainer }}
    >
      <Stack direction="column" spacing={2} margin={3} alignItems="center">
        <ImageComponent imgSrc={ICON_NO_DATA_COMPANY} width={150} />
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body1" color="text.secondary" maxWidth="800px" align="center">
          {content}
        </Typography>
        <Stack
          width="100%"
          direction="column"
          gap={1}
          padding={2}
          alignItems="flex-start"
          position="relative"
          bgcolor={theme.palette.success.light}
          borderRadius={theme.shape.borderRadius / 2}
        >
          <Typography variant="h6">Need assistance with an issue? </Typography>
          <Typography variant="body1">
            Feel free to contact our{' '}
            <Link href={LINK_SUPPORT} target="_blank">
              support team
            </Link>
            .
          </Typography>
          <ImageComponent
            imgSrc={ICON_SUPPORT_NO_DATA_COMPANY}
            width={100}
            style={{ position: 'absolute', top: theme.spacing(-3), right: theme.spacing(2) }}
          />
        </Stack>
      </Stack>
    </StyledWhiteBox>
  );
};

export default CompanyInfoNoData;
